import KunLoading69 from './src/index'

KunLoading69.install = function (Vue) {
	Vue.component(KunLoading69.name, KunLoading69);
}

export default KunLoading69;
